import { useMemo } from "react";
import { useRootStore } from "../../../stores/hooks";
import { buildGraph } from "../graph/build-graph";
import type { FlowGraph } from "../graph/types";

/** Derives the RF graph from the MobX candidate. Must be called from an
 *  `observer` component — MobX tracks the dereferenced observables and
 *  re-renders on any structural change; useMemo alone is NOT the reactivity
 *  mechanism, it only skips rebuilds between unrelated renders. */
export const useFlowGraph = (): FlowGraph => {
  const store = useRootStore();
  const candidate = store.automations.candidate;
  const actionGroups = candidate.self.actionGroups;
  const trigger = candidate.self.trigger;
  const collapsedLoopIds = store.flowCanvas.collapsedLoopIds;

  return useMemo(
    () =>
      buildGraph({
        trigger,
        actionGroups,
        // snapshot so the memo input is a stable value object
        collapsedLoopIds: new Set(collapsedLoopIds),
      }),
    // MobX observable arrays keep identity on mutation; depend on a cheap
    // structural fingerprint so the memo busts when the tree changes shape
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      trigger,
      actionGroups,
      JSON.stringify(actionGroups),
      collapsedLoopIds.size,
      JSON.stringify([...collapsedLoopIds]),
    ],
  );
};
